import React from 'react';

const visibilidadCamara = (camaraID, ini, data) => {
  const showCurulesIniShc = ini.showCurules && data?.shc;
  const selectedCamara =
    (camaraID && data.camaras.find(c => c.cam === camaraID)) || data.camaras[0];
  const isCircus = Number(selectedCamara?.cir ?? data.camaras[0].cir);
  let mostrarCargos = isCircus > 0 && showCurulesIniShc;
  let mostrarCandidatos = !(isCircus === 2);
  let mostrarSoloCandidatosConCargo = false;

  switch (data.elec) {
    case '2':
      if (data.amb === '00' && !mostrarCandidatos && mostrarCargos) {
        mostrarCandidatos = true;
        mostrarSoloCandidatosConCargo = true;
      }
      break;
    case '6':
    case '8':
    case '9':
      mostrarCargos = false;
      break;
    default:
  }

  return {
    mostrarCargos: mostrarCargos,
    mostrarCandidatos: mostrarCandidatos,
    mostrarSoloCandidatosConCargo: mostrarSoloCandidatosConCargo,
  };
};

export default visibilidadCamara;

// export function visibilidadTerritorios(props) {
//   let visibilidad
//     if (props.ambito.length>4) {
//       visibilidad = false
//     }else{
//       visibilidad = true
//     }
//     return visibilidad;
//   };

//   export function visibilidadCurules(props){
//   let visibilidad = true
//   return visibilidad;
// };

// export function visibilidadCandidatos(props){
//   let visibilidad = true
//   return visibilidad;
// };

// export function visibilidadVotosCandidatos(props){
//   let visibilidad = true
//   return visibilidad;
// };
